<template>
  <div class="logo" style="padding-left:0px;text-align:center;">
    <router-link :to="{name:'Console'}">
      <!-- <img src="../../assets/logo.png" alt=""> -->
      <h4 style="color:#fff;font-family: 'Arial Negreta', 'Arial Normal', Arial, sans-serif;font-weight: 700;font-style: normal;font-size:17px" v-if="showTitle">{{ this.titles }}</h4>
    </router-link>
  </div>
</template>

<script>
// import LogoSvg from '@/assets/logo.png'
import { mixin, mixinDevice } from '@/utils/mixin'

export default {
  name: 'Logo',
  // components: {
  //   LogoSvg
  // },
  mixins: [mixin, mixinDevice],
  data () {
    return {
      titles: ''
    }
  },
  props: {
    title: {
      type: String,
      default: '互联网医院综合业务管理平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  created () {
    if (this.layoutMode === 'topmenu') {
      if (this.title.length > 8) {
        // this.titles = this.title.substring(0, 7) + '...'
        this.titles = this.title
      } else {
        this.titles = this.title
      }
    } else {
      if (this.title.length > 10) {
        // this.titles = this.title.substring(0, 9) + '...'
        this.titles = this.title
      } else {
        this.titles = this.title
      }
    }
  }
}
</script>
